import type { Verdict } from "@/lib/types";

/** Kept out of the component files so Fast Refresh only sees components there. */
export const VERDICT_LABEL: Record<Verdict, string> = {
  apply: "Apply",
  maybe: "Maybe",
  skip: "Skip",
};

export const VERDICT_VARIANT: Record<
  Verdict,
  "success" | "warning" | "destructive"
> = {
  apply: "success",
  maybe: "warning",
  skip: "destructive",
};
